import React from 'react';
import classnames from 'classnames';
import s from './AvatarPlaceholder.scss';
const AvatarPlaceholder = ({ className , width , height , 'aria-hidden': ariaHidden , alt  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className),
        style: {
            width,
            height
        },
        "aria-hidden": ariaHidden
    }, /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 23 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: s['icon']
    }, /*#__PURE__*/ React.createElement("title", null, alt), /*#__PURE__*/ React.createElement("path", {
        d: "M11.6365 12.2222C15.0115 12.2222 17.7476 9.48618 17.7476 6.11111C17.7476 2.73604 15.0115 0 11.6365 0C8.2614 0 5.52536 2.73604 5.52536 6.11111C5.52536 9.48618 8.2614 12.2222 11.6365 12.2222Z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.52536 14.6667C2.8253 14.6667 0.636475 16.8555 0.636475 19.5556V20.3704C0.636475 21.2704 1.36608 22 2.2661 22H21.0068C21.9069 22 22.6365 21.2704 22.6365 20.3704V19.5556C22.6365 16.8555 20.4476 14.6667 17.7476 14.6667H5.52536Z"
    })));
};
AvatarPlaceholder.displayName = 'AvatarPlaceholder';
export default AvatarPlaceholder;
